var _defs, _sodipodiNamedview;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthConcerns({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 126.40613,
    height: 126.406,
    viewBox: "0 0 126.40613 126.406",
    sodipodidocname: "Health concerns.ai",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,94.805 H 94.805 V 0 H 0 Z",
    id: "path14"
  })))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview4",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapepageshadow: 2,
    inkscapepageopacity: 0,
    inkscapepagecheckerboard: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    inkscapegroupmode: "layer",
    inkscapelabel: "Health concerns",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,126.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    clipPath: "url(#clipPath16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(8.1927,36.6075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0.011,0 0.022,0 0.034,0 0.029,0 0.024,0 0.019,0 0.013,0 0.006,0 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "translate(38.7136,69.3849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -1.309,0.69 -2.797,1.086 -4.38,1.086 -5.212,0 -9.436,-4.225 -9.436,-9.436 0,-4.836 3.64,-8.816 8.329,-9.365 -0.184,-1.052 -0.285,-2.133 -0.285,-3.238 0,-10.322 8.368,-18.69 18.69,-18.69 6.983,0 13.067,3.833 16.275,9.507 C 16.298,-28.367 4.326,-16.488 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26",
    transform: "translate(70.3207,69.4523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -3.748,0 -6.976,-2.191 -8.499,-5.357 -2.931,1.911 -6.43,3.026 -10.191,3.026 -0.487,0 -0.967,-0.025 -1.445,-0.062 4.167,-10.36 12.084,-17.414 20.111,-17.852 -0.02,0.464 -0.051,0.925 -0.104,1.38 0.043,0 0.085,-0.006 0.128,-0.006 5.211,0 9.436,4.224 9.436,9.435 C 9.436,-4.224 5.211,0 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g30",
    transform: "translate(26.4185,19.6325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -2.002,0 -3.625,1.623 -3.625,3.625 V 8.97 h -5.013 c -2.002,0 -3.625,1.623 -3.625,3.625 0,2.002 1.623,3.625 3.625,3.625 h 5.013 v 5.013 c 0,2.003 1.623,3.626 3.625,3.626 2.002,0 3.625,-1.623 3.625,-3.626 V 16.22 H 8.97 c 2.003,0 3.626,-1.623 3.626,-3.625 0,-2.002 -1.623,-3.625 -3.626,-3.625 H 3.625 V 3.625 C 3.625,1.623 2.002,0 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g34",
    transform: "translate(74.9556,46.6604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -0.908,-12.073 -11.023,-21.619 -23.324,-21.619 -3.7,0 -7.2,0.867 -10.313,2.403 -1.399,-1.731 -3.536,-2.842 -5.93,-2.842 h -1.345 v -1.345 c 0,-4.204 -3.42,-7.625 -7.625,-7.625 -4.205,0 -7.625,3.421 -7.625,7.625 v 1.345 h -1.013 c -4.204,0 -7.625,3.421 -7.625,7.625 0,4.205 3.421,7.626 7.625,7.626 h 1.013 v 1.012 c 0,4.205 3.42,7.626 7.625,7.626 0.629,0 1.238,-0.085 1.823,-0.23 0,0.006 -0.001,0.011 -0.001,0.017 -4.795,2.288 -8.044,7.179 -8.044,12.757 0,7.795 6.342,14.137 14.137,14.137 3.935,0 7.635,-1.657 10.265,-4.433 2.268,0.714 4.646,1.083 7.033,1.083 3.043,0 6.027,-0.587 8.808,-1.72 2.605,2.543 6.149,4.051 9.881,4.051 7.795,0 14.137,-6.342 14.137,-14.137 C 9.502,7.184 5.525,1.923 0,0 m -4.671,42.245 c -22.922,12.638 -51.748,4.301 -64.386,-18.621 -12.637,-22.922 -4.3,-51.748 18.621,-64.386 22.922,-12.637 51.749,-4.3 64.386,18.621 12.638,22.922 4.301,51.749 -18.621,64.386",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g38",
    transform: "translate(31.9258,35.8529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -1.882 v 3.583 c -0.561,1.341 -1.003,2.743 -1.308,4.196 -0.629,0.529 -1.431,0.859 -2.317,0.859 -2.002,0 -3.625,-1.623 -3.625,-3.625 V 0 h -5.013 c -2.002,0 -3.625,-1.623 -3.625,-3.625 0,-2.002 1.623,-3.625 3.625,-3.625 h 5.013 v -5.345 c 0,-2.002 1.623,-3.625 3.625,-3.625 2.002,0 3.625,1.623 3.625,3.625 v 5.345 h 5.345 c 0.943,0 1.795,0.369 2.44,0.959 C 3.568,-4.578 1.565,-2.443 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthConcerns);
export default __webpack_public_path__ + "static/media/health_concerns.c68d01e502b15fb416d0668e6a66dd26.svg";
export { ForwardRef as ReactComponent };